var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inline-spinner",style:(`
    width: ${_vm.width}px;
    height: ${_vm.height}px;
    border: ${_vm.border}px solid;
    border-color: ${_vm.primaryColor} ${_vm.primaryColor} ${_vm.secondaryColor};
  `)})
}
var staticRenderFns = []

export { render, staticRenderFns }